import { Component, OnInit, Input, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { Transaction, Payment } from '../../models';
import { AlertService } from '../../services/alert.service';
import { TokenServiceService } from '../../services/token-service.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EmailValidator } from '../../tools/email-validator';
import { AVAILABLE_TRANSLATIONS, CURRENCIES } from '../../../assets/strings/translations';
import { environment } from '../../../environments/environment';
import { CONCEPTS } from '../../core/constants/Concepts';
import { DepositsManageService } from '../../services/deposits-manage.service';
import { ALERT_BUTTONS_MESSAGES, ALERT_MESSAGES } from '../../core/constants/AlertMessages';
import { createMerchantReturnUrl } from 'src/app/shared/helps/helps';

@Component({
    selector: 'app-transfer-bam',
    templateUrl: './transfer-bam.component.html',
    styleUrls: ['./transfer-bam.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class TransferBamComponent implements OnInit {
    @Input() info: Payment;
    @Input() currentConcept: any;
    @Output() BAM = new EventEmitter();

    public emailForm: FormGroup;

    urlReturnMerchant: string;
    orderID: string;
    transaction: Transaction;
    currentCountry: string = AVAILABLE_TRANSLATIONS.COL;
    loading: boolean;
    captchaKey = environment.captchaKey;
    template: string;
    user;

    readonly CONCEPTS = CONCEPTS;
    formPrivacyValid: boolean = false;

    constructor(
        private readonly tokenServiceService: TokenServiceService,
        private readonly formBuilder: FormBuilder,
        private readonly alertService: AlertService,
        private readonly depositManager: DepositsManageService
    ) {
        this.emailForm = this.formBuilder.group({
            email: ['', Validators.compose([Validators.required, EmailValidator.isValid])],
            recaptcha: ['', Validators.required],
        });
    }

    ngOnInit(): void {
        this.template = this.info.template;
        this.loading = false;
        this.transaction = this.tokenServiceService.getAndDecodeToken();
        this.urlReturnMerchant = createMerchantReturnUrl(this.orderID, this.transaction.MERCHANT_URL_RETURN);

        if (this.info.concept.length <= 1) {
            this.currentConcept = this.info.concept[0];
            if (this.info.template === 'cash') {
                this.user = 'Efectivo';
            } else if (this.info.category !== '5') {
                this.user = 'Transferencia';
            } else {
                this.user = 'Depósito';
            }
        } else if (this.transaction.ORDER_CURRENCY === CURRENCIES.CRC) {
            this.currentConcept = this.info.concept[0];
            if (this.info.category === '5') {
                this.user = CONCEPTS.DEPOSIT;
            } else if (this.info.category === '7') {
                this.user = CONCEPTS.TRANSFER_SINPE;
            }
        }
    }

    changeMethod() {
        this.BAM.emit();
    }
    /**
     *
     * @description {notCRC} Function to check if the current country is not Costa Rica (CRC)
     * @returns boolean - true if the current country is not CRC, otherwise false
     */
    notCRC() {
        return this.currentCountry != AVAILABLE_TRANSLATIONS.CRC;
    }

    get captcha() {
        return this.emailForm.get('recaptcha').value;
    }

    get email() {
        return this.emailForm.get('email').value;
    }

    /**
     *
     * @description {formPrivacyUpdate} Function that obtains the event of the validation of the child component
     * @param valid
     */
    formPrivacyUpdate = (valid: boolean) => {
        this.formPrivacyValid = valid;
    };
    /**
     *
     * @description {completedForms} Function to validate the validations of the parent component and child component
     * @returns
     */
    completedForms = (): boolean => {
        return this.formPrivacyValid && this.emailForm.valid;
    };

    /**
     * @description {sendEmail} Function to send transaction email with rate limit
     */
    sendEmail() {
        this.loading = true;
        if (this.completedForms()) {
            this.depositManager.sendEmailWithLimit(this.transaction.ORDER_CODE.toString(), this.email).subscribe({
                next: (response) => {
                    if (response) {
                        this.alertService.showPopup(ALERT_MESSAGES.EMAIL_SENT, ALERT_MESSAGES.EMAIL_SENT_MESSAGE, 'success', ALERT_BUTTONS_MESSAGES.THANKS);
                        this.loading = false;
                        return;
                    }
                    this.alertService.showAlertProblem();
                },
                error: () => {
                    this.loading = false;
                    this.alertService.showPopup(ALERT_MESSAGES.EMAIL_NOT_SENT, ALERT_MESSAGES.EMAIL_NOT_SENT_RATE_LIMIT, 'error', ALERT_BUTTONS_MESSAGES.THANKS);
                },
            });
        }
    }

    /**
     *
     * @description {resolved} Function to handle the resolved captcha response
     * @param captchaResponse - The response generated by the captcha
     * @returns void
     */
    resolved(captchaResponse: string) {
        this.emailForm.get('recaptcha').setValue(captchaResponse);
    }
}
